module.exports = __webpack_public_path__ + "static/media/lkw-7t.10db6f5f.svg";